import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Draggable from 'react-draggable';
import Paper from "@mui/material/Paper";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
export default function ConfirmationSaveDialog(props) {
  const { onClose, value: valueProp, open,isCrm,setIsCrm,missingFieldsMessage, ...other } = props;

  const handleCancel = () => {
    onClose();
    setIsCrm(false)
  };

  const handleOk = () => {
    onClose('ok');
    setIsCrm(false)
  };

  return (
    <React.Fragment>
      {isCrm ? (
        <Dialog
          maxWidth="sm"
          open={open}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
          {...other}
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            <div style={{ fontSize: "14px", whiteSpace: "pre-line" }}>
              <p style={{ marginBottom: "8px" }}>
                Are you sure you want to save?
              </p>

              {missingFieldsMessage && (
                <div>
                  <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
                    You're missing the following required fields:
                  </p>
                  <p>{missingFieldsMessage}</p>
                </div>
              )}
            </div>
          </DialogTitle>
          <DialogActions>
            <Button autoFocus onClick={handleCancel} color="primary">
              No
            </Button>
            <Button onClick={handleOk} color="primary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <Dialog
          maxWidth="sm"
          aria-labelledby="confirmation-dialog-title"
          open={open}
          {...other}
        >
          <DialogTitle id="confirmation-dialog-title">
            Do you want to save your changes?
          </DialogTitle>
          <DialogActions>
            <Button autoFocus onClick={handleCancel} color="primary">
              No
            </Button>
            <Button onClick={handleOk} color="primary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </React.Fragment>
  );
}

ConfirmationSaveDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
};